<template>
    <a-card>
        <a-steps v-if="canEdit" :current="step">
            <a-step title="填写基础信息"></a-step>
            <a-step title="生成申请书"></a-step>
            <a-step title="填写证明材料"></a-step>
            <a-step title="参与评审资料"></a-step>
            <a-step title="认证审核结果"></a-step>
        </a-steps>
        <a-steps v-else v-model:current="step">
            <a-step title="填写基础信息"></a-step>
            <a-step title="生成申请书"></a-step>
            <a-step title="填写证明材料"></a-step>
            <a-step title="参与评审资料"></a-step>
            <a-step title="认证审核结果"></a-step>
        </a-steps>
    </a-card>
    <div class="step-content" v-show="step===0">
        <a-form ref="ruleForm" layout="vertical" :model="form" :rules="baseRules" @submit="onSaveBaseInfo">
            <a-card :bordered="false">
                <template #title>
<!--                    <a-divider type="vertical" style="width: 5px;background-color: #0059b5"/>-->
                    <div class="tit">个人信息</div>
                </template>
                <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
                    <a-col :span="8">
                        <a-form-item label="照片" name="headShot" extra="一寸或两寸近期免冠证件照">
                            <img-upload v-model:value="form.headShot"/>
                        </a-form-item>
                    </a-col>
                    <a-col :span="16">
                        <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
                            <a-col :span="12">
                                <a-form-item label="姓名" name="name">
                                    <a-input v-model:value="form.name" placeholder="请输入"/>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="手机号码(登录账号)" name="phoneNumber">
                                    <a-input v-model:value="form.phoneNumber" disabled placeholder="请输入"/>
                                </a-form-item>
                            </a-col>

                            <a-col :span="12">
                                <a-form-item label="出生年月" name="birthday">
                                    <DatePicker style="width: 100%" v-model:value="form.birthday"
                                                :format="dateFormat.DATE_DAY"
                                                :showTime="false" placeholder="请输入"/>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="身份证号码" name="idCard">
                                    <a-input v-model:value="form.idCard" disabled placeholder="请输入"/>
                                </a-form-item>
                            </a-col>

                        </a-row>
                    </a-col>
                </a-row>
                <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
                    <a-col :span="8">
                        <a-form-item label="性别" name="sex">
                            <DictSelect v-model:value="form.sex" :dict-name="'sex'"
                                        placeholder="请选择"/>
                        </a-form-item>
                    </a-col>
                    <a-col :span="8">
                        <a-form-item label="民族" name="nation">
                            <DictSelect v-model:value="form.nation" :dict-name="'ethnic_group'"
                                        placeholder="请选择"/>
                        </a-form-item>
                    </a-col>
                    <a-col :span="8">
                        <a-form-item label="政治面貌" name="political">
                            <DictSelect v-model:value="form.political" :dict-name="'politicalOutlook'"
                                        placeholder="请选择"/>
                        </a-form-item>
                    </a-col>
                    <a-col :span="8">
                        <a-form-item label="电子邮箱" name="email">
                            <a-input v-model:value="form.email" placeholder="请输入"/>
                        </a-form-item>
                    </a-col>

                    <a-col :span="8">
                        <a-form-item label="最高学历" name="highestDegree">
                            <DictSelect v-model:value="form.highestDegree" :dict-name="'education_background'"
                                        placeholder="请选择"/>
                        </a-form-item>
                    </a-col>

                    <a-col :span="8">
                        <a-form-item label="参加工作时间" name="beginWorkDate">
                            <DatePicker style="width: 100%" v-model:value="form.beginWorkDate"
                                        :format="dateFormat.DATE_DAY"
                                        :showTime="false" placeholder="请输入"/>
                        </a-form-item>
                    </a-col>
                    <a-col :span="8">
                        <a-form-item label="毕业院校" name="collage">
                            <a-input v-model:value="form.collage" placeholder="请输入"/>
                        </a-form-item>
                    </a-col>
                    <a-col :span="8">
                        <a-form-item label="专业" name="major">
                            <a-input v-model:value="form.major" placeholder="请输入"/>
                        </a-form-item>
                    </a-col>
                    <a-col :span="8">
                        <a-form-item label="居住地址(省市区县)" name="address">
                            <all-city-select v-model:value="form.address" v-model:prov="form.addressProv"
                                             v-model:city="form.addressCity" v-model:dist="form.addressDist"/>
                        </a-form-item>
                    </a-col>
                    <a-col :span="8">
                        <a-form-item label="居住地址(详细地址)" name="addressDetail">
                            <a-input v-model:value="form.addressDetail" placeholder="请输入"/>
                        </a-form-item>
                    </a-col>
                    <a-col :span="8">
                        <a-form-item label="工作单位" name="workUnit">
                            <a-input v-model:value="form.workUnit" placeholder="请输入"/>
                        </a-form-item>
                    </a-col>
                    <a-col :span="8">
                        <a-form-item label="职务" name="position">
                            <a-input v-model:value="form.position" placeholder="请输入"/>
                        </a-form-item>
                    </a-col>
                    <a-col :span="8">
                        <a-form-item label="职称" name="positionalLevel">
<!--                            <a-input v-model:value="form.positionalLevel" placeholder="请输入"/>-->
                            <dict-select v-model:value="form.positionalLevel" dict-name="title_level"/>
                        </a-form-item>
                    </a-col>

                    <a-col :span="24">
                        <a-form-item label="单位类别" name="unitCategory">
                            <dict-radio v-model:value="form.unitCategory" dict-name="unit_category"/>
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-card>
            <a-card :bordered="false">
                <template #title>
<!--                    <a-divider type="vertical" style="width: 5px;background-color: #0059b5"/>-->
                    <div class="tit">其他信息</div>
                </template>
                <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
                    <a-col :span="24">
                        <a-form-item label="擅长专业领域" name="professionDomain">
                            <DictCheckbox v-model:value="form.professionDomain" dict-name="major_domain"/>
                        </a-form-item>
                    </a-col>
                    <a-col :span="24">
                        <a-form-item label="工作经历" name="workExperience">
                            <a-textarea v-model:value="form.workExperience" placeholder="请输入" :auto-size="{minRows:4,maxRows:6}"/>
                        </a-form-item>
                    </a-col>
                    <a-col :span="24">
                        <a-form-item label="主要研究成果及突出贡献" name="researchResult">
                            <a-textarea v-model:value="form.researchResult" placeholder="请输入" :auto-size="{minRows:4,maxRows:6}"/>
                        </a-form-item>
                    </a-col>
                </a-row>
                <div class="step-btn">
                    <a-button type="primary" @click="onSaveBaseInfo" v-if="canEdit">下一步</a-button>
                </div>
            </a-card>
        </a-form>
    </div>
    <div class="step-content" v-show="step===1">
        <a-card :bordered="false">
            <template #title>
                <div class="tit">生成申请书</div>
            </template>
            <div style="display: flex; justify-content: space-between; width: 100%; margin-bottom: 20px">
                <div>
                    <img src="@/assets/img/expert-state/word.png" alt=""><span style="margin-left: 10px; color: #0059B5">阳泉高新区信息化评审专家库成员申请表.docx</span>
                </div>
                <a-button type="primary" @click="genApplyFile">
                    <template #icon>
                        <DownloadOutlined />
                    </template>
                    下载
                </a-button>
            </div>
            <div class="tips-div">
                <img src="@/assets/img/expert-state/tips.png" alt="">
                <div>
                    <p>1.根据您填写的信息，系统已自动生成一份《阳泉高新区信息化评审专家库成员申请表》。</p>
                    <p>2.请下载生成的申请表，完成盖章扫描后，在第三步“填写证明材料”处上传PDF</p>
                </div>
            </div>
            <div class="step-btn">
                <a-button v-if="canEdit" type="default" @click="()=>{step--;form.professionDomain = form.professionDomain?.split(',')}">上一步</a-button>
                <a-divider type="vertical" />
                <a-button v-if="canEdit" type="primary" @click="step++">下一步</a-button>
            </div>
        </a-card>
    </div>
    <div class="step-content" v-show="step===2">
        <a-form ref="auditForm" layout="vertical" :model="form" :rules="auditRules" @submit="onSubmitAudit">
            <a-card :bordered="false">
                <template #title>
<!--                    <a-divider type="vertical" style="width: 5px;background-color: #0059b5"/>-->
                    <div class="tit">证明材料</div>
                </template>

                <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
                    <a-col :span="12">
                        <a-form-item label="专家库成员申请表(PDF)" name="applyFile" extra="请上传盖章后的PDF扫描件">
                            <FileUpload v-model:value="form.applyFile" is-pdf="true" :multiple="false" :size="50"
                                        :count="1"></FileUpload>

                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="身份证正反面(PDF)" name="idCardFile" extra="请上传身份证正反面的PDF扫描件">
                            <FileUpload v-model:value="form.idCardFile" is-pdf="true" :multiple="false" :size="50"
                                        :count="1"></FileUpload>
                        </a-form-item>
                    </a-col>
                </a-row>


            </a-card>
            <a-card :bordered="false">
                <template #title>
<!--                    <a-divider type="vertical" style="width: 5px;background-color: #0059b5"/>-->
                    <div class="tit">职称/职（执）业资格证书</div>
                </template>
                <template #extra>
                    <a-button type="primary" @click="onAddTitle" v-if="canEdit">
                        <template #icon>
                            <plus-outlined/>
                        </template>
                        新增
                    </a-button>
                </template>
                <a-table :columns="titleFileColumns" :data-source="titleFileData" :pagination="false">
<!--                    <template #fileLevel="{record}">-->
<!--                        <dict-render :text="record.fileLevel" :dict-obj="dictObjs['title_level']"/>-->
<!--                    </template>-->

                    <template #filePath="{record}">
                        <file-upload v-model:value="record.filePath" disabled/>
                    </template>

                    <template #action="{record}">
                        <a-button v-if="canEdit" type="danger" size="small" @click="onDelFile(record.id)">删除</a-button>
                    </template>
                </a-table>

            </a-card>

            <a-card :bordered="false">
                <template #title>
<!--                    <a-divider type="vertical" style="height: 14px;border-radius: 2px;width: 4px;background-color: #0059b5"/>-->
<!--                    <span style="color: #0059b5;font-weight: bold">其他证书（学历学位，研究成果，荣誉证书）</span>-->
                    <div class="tit">其他证书（学历学位，研究成果，荣誉证书）</div>
                </template>
                <template #extra>
                    <a-button type="primary" @click="onAddOther" v-if="canEdit">
                        <template #icon>
                            <plus-outlined/>
                        </template>
                        新增
                    </a-button>
                </template>
                <a-table :columns="otherFileColumns" :data-source="otherFileData" :pagination="false">
                    <template #fileCategory="{record}">
                        <dict-render :text="record.fileCategory" :dict-obj="dictObjs['file_category']"/>
                    </template>

                    <template #filePath="{record}">
                        <file-upload v-model:value="record.filePath" disabled/>
                    </template>

                    <template #action="{record}">
                        <a-button v-if="canEdit" type="danger" @click="onDelFile(record.id)">删除</a-button>
                    </template>
                </a-table>

                <div class="step-btn">
                    <a-button type="default" v-if="canEdit" @click="step--">上一步</a-button>
                    <a-divider type="vertical" />
                    <a-button type="primary" @click="onSubmitAudit"  v-if="canEdit">下一步</a-button>
                </div>
            </a-card>
        </a-form>
    </div>

    <div class="step-content" v-show="step===3">
        <a-card :bordered="false">
            <template #title>
                <a-divider type="vertical" style="width: 5px;background-color: #0059b5"/>
                <span style="color: #0059b5;font-weight: bold">评审资料</span>
            </template>
            <a-form ref="otherForm" layout="vertical" :model="form" :rules="otherRules" @submit="onSubmitOther">
                <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }">
                    <a-col :span="12">
                        <a-form-item label="个人签名(图片)" name="signatureFile">
                            <user-sign :file-id="form.signatureFile" @finish="changeSign"></user-sign>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="签名样例">
                            <img src="@/assets/svg/签名.png" alt="签名模板">
                        </a-form-item>
                    </a-col>

                    <a-col :span="12">
                        <a-form-item label="银行账号" name="bankAccount">
                            <a-input v-model:value="form.bankAccount" placeholder="请输入银行账号"/>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="银行名称" name="bankName">
                            <a-input v-model:value="form.bankName" placeholder="请输入银行名称"/>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="行号" name="bankNo">
                            <a-input v-model:value="form.bankNo" placeholder="请输入行号"/>
                        </a-form-item>
                    </a-col>
                </a-row>
                <div class="step-btn">
                    <a-button type="default" @click="step--" v-if="canEdit">上一步</a-button>
                    <a-divider type="vertical" />
                    <a-button type="primary" @click="onSubmitOther"  v-if="canEdit">提交审核</a-button>
                </div>
            </a-form>
        </a-card>
    </div>
    <div class="step-content" v-if="step===4">
        <a-card>
            <div style="display: flex;flex-direction: column;align-items: center;">
                <div>
                    <img v-if="form.auditState==='2'" :src="fail" alt="">
                    <img v-else :src="success" alt="">
                </div>
<!--                <div class="step4-div" style="font-size: 18px">
                    <span style="color: #0059B5;" v-if="form.auditState==='0'">等待审核</span>
                    <span style="color: darkgreen;" v-if="form.auditState==='1'">认证成功</span>
                    <span style="color: #E74700;" v-if="form.auditState==='2'">审核失败</span>
                </div>-->
                <div class="step4-div">
                    <span v-if="form.auditState==='0'">资料已经提交，请等待审核！</span>
                    <span v-if="form.auditState==='1'">请关注聘用公示</span>
                    <span v-if="form.auditState==='2'">请重新提交！</span>
                </div>
                <div class="step4-div">
                    <a-button type="primary" @click="step=0" v-if="canEdit">返回</a-button>
                </div>
            </div>
        </a-card>
    </div>

    <add-title-file ref="title" @finish="getTitleFile"/>
    <add-other-file ref="other" @finish="getOtherFile"/>
</template>

<script>
import dataCheck from "@/utils/dataCheck";
import {dictMixin, formMixin} from "@/mixins";
import {expert, expert_file} from "@/api/projectReviewService";
import FileUpload from "@/components/form/upload/FileUpload";
import UserSign from "@/views/sys/expert/expertInfo/components/userSign.vue";
import DictSelect from "@/components/other/DictSelect.vue";
import DictRadio from "@/components/other/DictRadio.vue";
import AllCitySelect from "@/components/form/select/AllCitySelect.vue";
import DatePicker from "@/components/form/datePicker/DatePicker.vue";
import {dateFormat} from "@/config/variableConfig";
import DictCheckbox from "@/components/other/DictCheckbox.vue";
import ImgUpload from "@/components/form/upload/ImgUpload.vue";
import {filterObj, ls} from "@/utils/util";
import pick from "lodash.pick";
import DictRender from "@/components/other/DictRender.vue";
import axios from "axios";
import AddTitleFile from "@/views/sys/expert/expertAudit/components/AddTitleFile.vue";
import AddOtherFile from "@/views/sys/expert/expertAudit/components/AddOtherFile.vue";
import {DownloadOutlined} from "@ant-design/icons-vue";
const fail = require('@/assets/img/expert-state/审核失败.png')
const success = require('@/assets/img/expert-state/审核成功.png')
export default {
    name: "Audit",
    computed: {
        dateFormat() {
            return dateFormat
        },
        canEdit(){
            return this.expert.auditState!=='1' && this.expert.auditState!=='0'
        }
    },
    components: {
        AddOtherFile,
        AddTitleFile,
        DictRender,
        ImgUpload,
        DictCheckbox,
        DatePicker,
        AllCitySelect,
        DictRadio,
        DictSelect,
        UserSign,
        FileUpload,
        DownloadOutlined
    },
    mixins: [formMixin, dictMixin],
    data() {
        return {
            success,
            fail,
            dictNames: 'sex,title_level,ethnic_group,education_background,file_category',
            expert: {},
            form: {},
            step: 0,
            baseRules: {
                id: [],
                headShot: [dataCheck.required({})],
                name: [dataCheck.required({})],
                // idCard: [dataCheck.required({}), dataCheck.id_num],
                // phoneNumber: [dataCheck.required({}), dataCheck.mobile_phone,],
                birthday: [dataCheck.required({})],
                sex: [dataCheck.required({})],
                nation: [dataCheck.required({})],
                email: [dataCheck.required({})],
                political: [dataCheck.required({})],
                highestDegree: [dataCheck.required({msg: "请输入最高学历"})],
                collage: [dataCheck.required({msg: "请输入毕业院校"})],
                major: [dataCheck.required({msg: "请输入专业"})],
                beginWorkDate: [dataCheck.required({msg: "请输入参加工作时间"})],
                address: [dataCheck.multiple],
                addressProv: [dataCheck.required({msg: "请输入现居住地"})],
                addressCity: [dataCheck.required({msg: "请输入现居住地"})],
                addressDist: [dataCheck.required({msg: "请输入现居住地"})],
                addressDetail: [],
                workUnit: [dataCheck.required({msg: "请输入工作单位"})],
                position: [dataCheck.required({msg: "请输入职务"})],
                unitCategory: [dataCheck.required({msg: "请输入单位性质"})],
                // positional: [dataCheck.required({msg: "请输入职称/职(执)资格证书名称"})],
                positionalLevel: [dataCheck.required({msg: "请选择职称"})],
                professionDomain: [dataCheck.multiple],
                workExperience: [dataCheck.required({msg: "请输入工作经历"})],
                researchResult: [dataCheck.required({msg: "请输入研究成果"})],
            },
            auditRules: {
                id: [],
                applyFile: [dataCheck.required({msg: "请上传专家库成员申请表"})],
                idCardFile: [dataCheck.required({msg: "请上传身份证"})],
                positional: [dataCheck.required({msg: "请输入职称/职(执)资格证书名称"})],
                positionalFile: [dataCheck.required({msg: "请上传职称/职(执)证书"})],
                credentials: [],
            },
            otherRules: {
                id: [],
                bankAccount: [dataCheck.required({msg: "请输入银行账号"})],
                bankName: [dataCheck.required({msg: "请输入银行名称"})],
                bankNo: [dataCheck.required({msg: "请输入行号"})],
                signatureFile: [dataCheck.required({msg: "请上传个人签名图片"})],
            },
            submitUrl: expert.save,
            titleFileData: [],
            titleFileColumns: [
                {title: '职称/职（执）业资格名称', dataIndex: 'fileName', key: 'fileName', slots: {customRender: 'title',}},
                // {title: '职称/职(执)资格等级', dataIndex: 'fileLevel', key: 'fileLevel', slots: {customRender: 'fileLevel',}},
                {title: '职称/职(执)资格附件', dataIndex: 'filePath', key: 'filePath', slots: {customRender: 'filePath',}},
                {title: '操作', dataIndex: 'action', key: 'action', slots: {customRender: 'action'}, width:'120px'},
            ],
            otherFileData: [],
            otherFileColumns: [
                // {title: '证书名称', dataIndex: 'fileName', slots: {customRender: 'fileName',}},
                {title: '证书类型', dataIndex: 'fileCategory', slots: {customRender: 'fileCategory',}},
                {title: '证书附件', dataIndex: 'filePath', slots: {customRender: 'filePath',}},
                {title: '操作', dataIndex: 'action', slots: {customRender: 'action'}, width:'120px'},
            ]
        }
    },
    async mounted() {
        await this.getExpertInfo()
        this.getOtherFile()
        this.getTitleFile()
    },
    methods: {
        genApplyFile(){
            const loading = this.$message.loading('正在下载...', 0)
            axios({
                methods: 'get',
                url: expert.genFile,
                responseType: 'blob',
                headers: {
                    'content-type': 'application/x-www-form-urlencoded',
                    Authorization: 'Bearer' + ls.get('token') || ''
                },
                params:{
                    expertId: this.form.id
                }
            }).then(data => {
                this.confirmLoading = false
                const blob = new Blob([data.data], {type: "application/docx"});
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a"); // 创建a标签
                link.href = url;
                link.download = decodeURIComponent('阳泉高新区信息化项目评审专家库成员申请表.docx');// 文件重命名，若无需重命名，将该行删去
                link.click();
                URL.revokeObjectURL(url); // 释放内存
                loading()
                // this.step++
            })
        },
        async getExpertInfo() {
            await this.getAction({
                url: expert.current
            }).then(res => {
                res.professionDomain = res.professionDomain?.split(",")
                this.expert = {...res}
                this.form = {...res}
                if (res.headShot==='1otse7lar0qwixte6bng|userPhoto.jpg'){
                    this.expert.headShot=''
                    this.form.headShot=''
                }
            })
        },
        changeSign(val) {
            this.form.signatureFile = val
        },
        async onSaveBaseInfo() {
            const valid = await this.$refs.ruleForm.validate()
            this.form.professionDomain = this.form.professionDomain.join(",")
            if (valid) {
                this.postAction({
                    url: expert.save,
                    params: filterObj(this.getSubmitParams(this.form, this.baseRules))
                }).then(() => {
                    this.step++
                })
            } else {
                console.log("表单验证失败");
            }
        },
        async onSubmitAudit() {
            const valid = await this.$refs.auditForm.validate()
            if (this.titleFileData.length<1){
                this.$message.error("请上传职称/职(执)证书")
                return
            }
            if (valid) {
                this.form.positionalFile = this.titleFileData.map(t=>t.filePath).join(",")
                this.form.credentials = this.otherFileData.map(t=>t.filePath).join(",")
                this.form.positional = this.titleFileData.map(t=>t.fileName).join(",")
                this.postAction({
                    url: expert.save,
                    params: filterObj(this.getSubmitParams(this.form, this.auditRules))
                }).then(() => {
                    this.step++
                })
            } else {
                console.log("表单验证失败");
            }
        },
        onSubmitOther() {
            this.$refs.otherForm.validate().then(() => {
                this.postAction({
                    url: expert.audit,
                    params: filterObj(this.getSubmitParams(this.form, this.otherRules))
                }).then(() => {
                    this.step++
                    this.getExpertInfo()
                })
            })
        },
        getSubmitParams(form, rules) {
            return pick(
                Object.assign({}, form),
                Object.keys(rules)
            );
        },
        onDelFile(id){
            this.postAction({
                url: expert_file.delete,
                params: {id:id}
            }).then(()=>{
                this.getTitleFile()
                this.getOtherFile()
            })
        },
        getTitleFile(){
            this.getAction({
                url: expert_file.getTitleByExpert,
                params:{expertId: this.expert.id}
            }).then(resp=>{
                this.titleFileData = resp
            })
        },
        getOtherFile(){
            this.getAction({
                url: expert_file.getOtherByExpert,
                params:{expertId: this.expert.id}
            }).then(resp=>{
                this.otherFileData = resp
            })
        },
        onAddTitle(){
            const title = this.$refs.title;
            title.form={
                fileCategory: "1",
                expertId: this.expert.id
            }
            title.visible = true
        },
        onAddOther(){
            const title = this.$refs.other;
            title.form={
                expertId: this.expert.id
            }
            title.visible = true
        },
    }
}
</script>

<style scoped lang="less">
.step-content {
    margin-top: 15px;
}

.ant-card + .ant-card {
    margin-top: 15px;
}

:deep(.ant-card-head) {
    border-bottom: 2px solid #f0f0f0;
}
:deep(.ant-upload-list-item){
    margin-top: 0;
}
//#idCardFile > span > div.ant-upload.ant-upload-select.ant-upload-select-text > span > button
:deep(.ant-upload  .ant-btn){
    background-color: #0059b5 !important;
    color: #fff !important;
}
.tit{
    color: #0059b5;
    font-weight: 400;
    font-size: 16px;
    padding-left: 10px;
    position: relative;
    &::before{
        content:'';
        display:block;
        width: 4px;
        height: 14px;
        background: #0059B5;
        border-radius: 2px;
        position: absolute;
        top:5px;
        left:0;
    }
}
.step4-div{
    margin-top: 15px;
}
.step-btn{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
}
.step-btn .ant-divider-vertical{
    border-left: 2px solid rgba(0, 0, 0, 0.06)
}
:deep(.ant-form-item-extra){
    color: orangered;
}
:deep(.ant-upload-list-picture-card .ant-upload-list-item) {
    margin: 0;
    padding: 5px;
    width: 83px;
    height: 116px;
    //border:0;
    //border-radius:0;
}

:deep(.ant-upload-list-picture-card-container) {
    margin: 0;
    width: 81px;
    height: 114px;
}
:deep(.ant-upload.ant-upload-select-picture-card){
    margin: 0;
    width: 84px;
    height: 113px;
}
.tips-div{
    display: flex;
    height: 70px;
    background: rgba(255,106,54,0.1);
    border-radius: 4px;
    border: 1px solid #FF6A36;

    font-family: Microsoft YaHei,serif;
    font-weight: 400;
    font-size: 14px;
    color: #FF6A36;
    line-height: 24px;

    padding: 10px;
}
</style>
